import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Category as SchemaCategory } from '../schemas/Category';
import { type ChangedCategory as SchemaChangedCategory } from '../schemas/ChangedCategory';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const UpdateCategoryContentType = 'application/json' as const;
export type UpdateCategoryRequest = SchemaChangedCategory;
export type UpdateCategoryResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategory;
    };
};
export type UpdateCategoryResponseSuccess = UpdateCategoryResponses['200']['application/json'];
export type UpdateCategorySearchParams = undefined;
export type UpdateCategoryPathParameters = {
    id: string;
};
export const UpdateCategoryUrl = '/categories/{id}' as const;
export const UpdateCategoryMethod = 'PUT' as const;
export const getUpdateCategoryUrl = (params: UpdateCategoryPathParameters) =>
    UpdateCategoryUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateCategoryPathParameters) =>
        String(params[param])
    );
